module.exports = __webpack_public_path__ + "static/media/maintanance.f521a8b1.svg";